// Same-origin mount for the API proxy route handler (apps/web/src/app/api/[...path]/route.ts).
export const API_BASE_PATH = "/api";
